module.exports = __webpack_public_path__ + "img/kontenery_inactive.ee9468b5.svg";